export default [
  {
    name: "merrimint container",
    type: "gltf",
    path: "/models/merrimint-jar.gltf",
  }
];
